// Import the functions you need from the SDKs you need
import { getDatabase } from "firebase/database";
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC0u0DbX8HpzhzOmEHDq7X17w6_w-DeJUg",
  authDomain: "xdrip-airdrop.firebaseapp.com",
  projectId: "xdrip-airdrop",
  storageBucket: "xdrip-airdrop.appspot.com",
  messagingSenderId: "160379559519",
  appId: "1:160379559519:web:ab10e10c16c55f07bdc5ea"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase();
export default database;